import Tooltip from "app/common/Tooltip";
import React from "react";
import "./IconList.scss";

export type IconProps = {
  show: boolean;
  toolTipText: string;
  callBack: (id: any) => void;
  position: string;
  data?: any;
  type?: any;
};

export const EditIcon: React.FC<IconProps> = ({ show, type, ...props }) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="bottom">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              props.callBack(e.target);
            }
          }}
          onClick={props.callBack}
          tabIndex={0}
        >
          <g fillRule="nonzero" fill="none">
            <path
              d="M8.76 18.323c.1-.1-.778-.686-.877-.786L5.037 14.9v.24L3.723 20.68l5.531-1.286-.494-1.07zM9.833 20.8l-6.949 1.615a.75.75 0 0 1-.9-.904l1.642-6.922a.75.75 0 0 1 .2-.358L15.578 2.48a1.763 1.763 0 0 1 2.488 0l3.868 3.868a1.762 1.762 0 0 1 0 2.487l-11.64 11.642a.739.739 0 0 1-.461.323z"
              fill="#000"
            />
            <path
              d="M13.043 6.73a.75.75 0 0 1 1.06-1.06l4.653 4.653a.75.75 0 0 1-1.06 1.06l-4.653-4.652z"
              className="no-fill"
              fill="#FFF"
            />
            <path
              d="M4.834 15.147a.75.75 0 1 1 1.06-1.06l4.457 4.456a.75.75 0 1 1-1.06 1.06l-4.457-4.456z"
              fill="#000"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);



export const AssignIcon: React.FC<IconProps> = ({ show, type, ...props }) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="bottom">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onClick={props.callBack}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              props.callBack(e.target);
            }
          }}
          tabIndex={0}
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="m11.62 13.488.061.001c.193.008.52.027.937.063.695.061 1.391.15 2.047.27.127.024.251.048.373.074.688.145.938.872.452 1.314-.24.218-.31.282-.415.382-.714.681-.988 1.188-1.062 2.2-.082 1.13.454 2.096 1.54 2.87.667.474.276 1.403-.59 1.403l-12.374.007c-.511 0-.926-.354-.926-.792 0-3.524 1.932-5.795 5.084-6.963a13.612 13.612 0 0 1 3.16-.733 13.39 13.39 0 0 1 1.713-.096zM10.321 2.725c2.838 0 5.138 2.283 5.138 5.1 0 2.816-2.3 5.099-5.138 5.099-2.837 0-5.138-2.283-5.138-5.1 0-2.816 2.301-5.099 5.138-5.099z"
              fill="#000"
              fillRule="nonzero"
            />
            <path
              d="M22.5 17.682c0 2.772-2.264 5.018-5.056 5.018-2.793 0-5.056-2.246-5.056-5.018s2.263-5.018 5.056-5.018c2.792 0 5.056 2.246 5.056 5.018z"
              fill="#000"
              fillRule="nonzero"
            />
            <path
              fill="#FFF"
              className="no-fill"
              d="M17.079 14.269h1.432v6.684h-1.432z"
            />
            <path
              fill="#FFF"
              className="no-fill"
              d="M21.137 16.895v1.433h-6.684v-1.433z"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);
export const ShareIcon: React.FC<IconProps> = ({ show, type, ...props }) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="bottom">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onClick={props.callBack}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              props.callBack(e.target);
            }
          }}
          tabIndex={0}
        >
          <g fill="#000" fillRule="evenodd">
            <path
              d="M12.216 5a.75.75 0 0 1 1.192-.606l8.787 6.406c.41.3.41.912 0 1.212l-8.787 6.406a.75.75 0 0 1-1.192-.606v-2.958c-1.538-.134-3.278.088-4.92.913-1.44.723-2.658 1.859-3.594 3.488-.356.62-1.295.437-1.393-.271a5.421 5.421 0 0 1-.03-.308c-.12-1.556.075-3.366.843-5.111 1.4-3.177 4.344-5.177 9.094-5.433V5zm1.5 1.475v2.381a.75.75 0 0 1-.738.75c-4.608.073-7.252 1.77-8.483 4.564a8.853 8.853 0 0 0-.66 2.366 9.63 9.63 0 0 1 2.788-2.11c2.03-1.019 4.151-1.249 6.014-1.037.22.025.382.05.477.07a.75.75 0 0 1 .602.735v2.143l6.764-4.931-6.764-4.931z"
              fillRule="nonzero"
            />
            <path d="m12.695 8.844-4.963.971-2.962 2.371-1.664 3.417v2.394l2.4-2.007 3.625-1.826h3.564l.319.683.206 2.534 8.462-5.876L13.22 5.37z" />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);

export const SaveIcon: React.FC<IconProps> = ({ show, type, ...props }) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="top">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          tabIndex={0}
          onClick={props.callBack}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              props.callBack(e.target);
            }
          }}
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M13.043 6.73a.75.75 0 0 1 1.06-1.06l4.653 4.653a.75.75 0 0 1-1.06 1.06l-4.653-4.652z"
              fill="#FFF"
              className="no-fill"
              fillRule="nonzero"
            />
            <path
              d="M2 2c9.06-.633 14.635.184 16.724 2.45 2.089 2.267 3.133 8.019 3.133 17.256l-19.016.728L2 2z"
              fill="#000"
            />
            <path
              d="M14.923.967a.75.75 0 0 1 .51.201l6.316 5.87a.75.75 0 0 1 .24.55v13.715c0 .69-.562 1.251-1.252 1.251H3.102a1.134 1.134 0 0 1-1.135-1.133V1.967a1 1 0 0 1 1-1h11.956zm-6.906 1.5h-4.55v18.587h2.814l.001-7.755a.75.75 0 0 1 .75-.75h10.219a.75.75 0 0 1 .75.75v7.754l2.488.001V7.914L15.63 3.4v4.296a.75.75 0 0 1-.75.75H8.769a.75.75 0 0 1-.75-.75V2.466zm8.484 11.582H7.782v7.005h8.719V14.05zm-2.006 4.254a.75.75 0 0 1 0 1.5H9.789a.75.75 0 1 1 0-1.5h4.706zm0-3.004a.75.75 0 0 1 0 1.5H9.789a.75.75 0 1 1 0-1.5h4.706zm-.363-12.832H9.518v4.478h4.614V2.467z"
              className="no-fill"
              fill="#FFF"
              fillRule="nonzero"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);

export const CancelIcon: React.FC<IconProps> = ({ show, type, ...props }) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="bottom">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onClick={props.callBack}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              props.callBack(e.target);
            }
          }}
          tabIndex={0}
        >
          <g fill="none" fillRule="evenodd">
            <circle fill="#000" cx="12" cy="12" r="12" />
            <path
              className="no-fill"
              d="m15.68 9.479-2.52 2.533 2.533 2.548a.75.75 0 0 1 .07.977l-.073.084a.75.75 0 0 1-1.06-.003l-2.528-2.543-2.526 2.543a.75.75 0 1 1-1.064-1.058l2.532-2.548L8.526 9.48c-.681-.685.287-1.694.99-1.125l.073.067 2.514 2.527 2.513-2.527c.705-.709 1.769.349 1.064 1.058z"
              fill="#FFF"
              fillRule="nonzero"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);

export const RemoveIcon: React.FC<IconProps> = ({
  show,
  data,
  type,
  ...props
}) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="bottom">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => props.callBack(data)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              props.callBack(e.target);
            }
          }}
          tabIndex={0}
        >
          <g fill="none" fillRule="evenodd">
            <circle fill="#000" cx="12" cy="12" r="12" />
            <path
              className="no-fill"
              d="m15.68 9.479-2.52 2.533 2.533 2.548a.75.75 0 0 1 .07.977l-.073.084a.75.75 0 0 1-1.06-.003l-2.528-2.543-2.526 2.543a.75.75 0 1 1-1.064-1.058l2.532-2.548L8.526 9.48c-.681-.685.287-1.694.99-1.125l.073.067 2.514 2.527 2.513-2.527c.705-.709 1.769.349 1.064 1.058z"
              fill="#FFF"
              fillRule="nonzero"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);

export const LeaveIcon: React.FC<IconProps> = ({
  show,
  data,
  type,
  ...props
}) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="bottom">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => props.callBack(data)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              props.callBack(data);
            }
          }}
          tabIndex={0}
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="m11.62 13.488.061.001c.193.008.52.027.937.063.695.061 1.391.15 2.047.27.127.024.251.048.373.074.688.145.938.872.452 1.314-.24.218-.31.282-.415.382-.714.681-.988 1.188-1.062 2.2-.082 1.13.454 2.096 1.54 2.87.667.474.276 1.403-.59 1.403l-12.374.007c-.511 0-.926-.354-.926-.792 0-3.524 1.932-5.795 5.084-6.963a13.612 13.612 0 0 1 3.16-.733 13.39 13.39 0 0 1 1.713-.096zM10.321 2.725c2.838 0 5.138 2.283 5.138 5.1 0 2.816-2.3 5.099-5.138 5.099-2.837 0-5.138-2.283-5.138-5.1 0-2.816 2.301-5.099 5.138-5.099z"
              fill="#000"
              fillRule="nonzero"
            />
            <path
              d="M22.5 17.682c0 2.772-2.264 5.018-5.056 5.018-2.793 0-5.056-2.246-5.056-5.018s2.263-5.018 5.056-5.018c2.792 0 5.056 2.246 5.056 5.018z"
              fill="#000"
              fillRule="nonzero"
            />
            <path
              className="no-fill"
              fill="#FFF"
              d="M21.137 16.895v1.433h-6.684v-1.433z"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);

export const Pair: React.FC<IconProps> = ({ show, data, ...props }) => (
  <React.Fragment>
    {show === true && (
      <span
        className="pairLabel"
        onClick={() => props.callBack(data)}
        tabIndex={0}
      >
        Pair
      </span>
    )}
  </React.Fragment>
);

export const UnPair: React.FC<IconProps> = ({ show, data, ...props }) => (
  <React.Fragment>
    {show === true && (
      <span
        className="pairLabel"
        onClick={() => props.callBack(data)}
        tabIndex={0}
      >
        Unpair
      </span>
    )}
  </React.Fragment>
);
const EditLine: React.FC<any> = ({
  actions,
  type,
  data,
  isPared,
  handleMouseLeave,
}) => {
  return (
    <React.Fragment>
      {actions && (
        <div className="icons">
          {!isPared && (
            <div className="leftPanel">
              <EditIcon {...actions.pencil} />
              <div className="innerLeftPanel">
                <div className="saveIcon">
                  <SaveIcon {...actions.save} />
                </div>
                {type === "lineDetails" && (
                  <div className="cancelIcon">
                    <CancelIcon {...actions.cancel} />
                  </div>
                )}
              </div>
            </div>
          )}
          {isPared && <div className="leftPanel"></div>}
          <div className="rightPanel" onBlur={handleMouseLeave}>
            {type === "delveDetails" && (
              <RemoveIcon {...actions.remove} data={data} />
            )}

            <ShareIcon {...actions.share} />
            <AssignIcon {...actions.assign} />
            <LeaveIcon {...actions.leave} />
            {actions.unpair.show === true && (
              <span
                className="pairLabel"
                onClick={() => actions.unpair.callBack(data)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    actions.unpair.callBack(data);
                  }
                }}
                tabIndex={0}
              >
                Unpair
              </span>
            )}
            {actions.pair.show === true && (
              <span
                className="pairLabel"
                onClick={() => actions.pair.callBack(data)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    actions.pair.callBack(data);
                  }
                }}
                tabIndex={0}
              >
                Pair
              </span>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export const IconListMobile: React.FC<any> = ({ actions, type, data }) => {
  return (
    <React.Fragment>
      {actions && (
        <div className="editTooltip">
          <div className="icons mobile-icons">
            <div className="">
              <EditIcon {...actions.pencil} />
              <div className="">
                <div className="">
                  <SaveIcon {...actions.save} />
                </div>
                {type === "lineDetails" && (
                  <div className="cancelIcon">
                    <CancelIcon {...actions.cancel} />
                  </div>
                )}
              </div>
            </div>
            <div className="">
              <ShareIcon {...actions.share} />
              <AssignIcon {...actions.assign} />
              <LeaveIcon {...actions.leave} />
              {actions.unpair.show === true && (
                <span
                  className="pairLabel"
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (event.keyCode === 13) {
                      actions.unpair.callBack(data);
                    }
                  }}
                  onClick={() => actions.unpair.callBack(data)}
                >
                  Unpair
                </span>
              )}
              {actions.pair.show === true && (
                <span
                  className="pairLabel"
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (event.keyCode === 13) {
                      actions.pair.callBack(data);
                    }
                  }}
                  onClick={() => actions.pair.callBack(data)}
                >
                  Pair
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export const IconListDevMobile: React.FC<any> = ({
  actions,
  deviceData,
  data,
}) => {
  return (
    <React.Fragment>
      {actions && (
        <div
          className={`rightPanel ${deviceData ? "right-expand-action" : ""}`}
        >
          {<RemoveIcon {...actions.remove} data={data} />}

          {actions.unpair.show === true && (
            <span
              className="pairLabel"
              tabIndex={0}
              onClick={() => actions.unpair.callBack(data)}
            >
              Unpair
            </span>
          )}
          {actions.pair.show === true && (
            <span
              className="pairLabel"
              tabIndex={0}
              onClick={() => actions.pair.callBack(data)}
            >
              Pair
            </span>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export const EditLineIcons: React.FC<any> = ({ actions, type }) => {
  return (
    <React.Fragment>
      {actions && (
        <div className="icons">
          <div className="leftPanel">
            <EditIcon {...actions.pencil} />
            <div className="innerLeftPanel">
              <div className="saveIcon">
                <SaveIcon {...actions.save} />
              </div>
              {type === "lineDetails" && (
                <div className="cancelIcon">
                  <CancelIcon {...actions.cancel} />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export default EditLine;
